import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";

import { useIntlTranslate } from "../../hooks";
import { getAppTitle } from "../../store/config.selectors";

interface AriaPageTitleProps {
  pageKey: string;
  pageValues?: Record<string, string>;
}

export const AriaPageTitle = ({ pageKey, pageValues }: AriaPageTitleProps) => {
  const rootElement = document.querySelector("#root") || document.body;
  const translate = useIntlTranslate();
  const appTitle = useSelector(getAppTitle);
  const title = translate("page_title", {
    page: translate(pageKey, pageValues),
    appTitle,
  });

  useEffect(() => {
    document.title = title;
  }, [title]);

  return createPortal(
    <div className="sr-only" tabIndex={-1} role="status" aria-atomic={true}>
      {title}
    </div>,
    rootElement
  );
};
